import React from 'react';

const Footer = () => {
  return (
    <footer id="contact" className="bg-background py-24 border-t border-white/5">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-12">
          <div>
            <h2 className="text-3xl font-serif text-white mb-4">KAPI LEVENTE</h2>
            <p className="text-text-muted font-light max-w-xs">
              Where music, presence, and intention meet.
            </p>
          </div>
          
          <div className="flex flex-col md:flex-row gap-8 md:gap-16">
            <div className="flex flex-col gap-4">
              <span className="text-primary text-xs uppercase tracking-widest mb-2">Social</span>
              <a href="#" className="text-text-muted hover:text-white transition-colors text-sm">Instagram</a>
              <a href="#" className="text-text-muted hover:text-white transition-colors text-sm">Spotify</a>
              <a href="#" className="text-text-muted hover:text-white transition-colors text-sm">SoundCloud</a>
            </div>
            <div className="flex flex-col gap-4">
              <span className="text-primary text-xs uppercase tracking-widest mb-2">Contact</span>
              <a href="mailto:hello@kapilevente.com" className="text-text-muted hover:text-white transition-colors text-sm">hello@kapilevente.com</a>
              <a href="#" className="text-text-muted hover:text-white transition-colors text-sm">Press Kit</a>
            </div>
          </div>
        </div>
        
        <div className="mt-24 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-6 text-xs text-text-muted/50 uppercase tracking-widest">
          <p>&copy; {new Date().getFullYear()} Kapi Levente. All rights reserved.</p>
          <p>Designed with Consciousness</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
